import ClipList from "./ClipList";

export default ClipList;
